export default "__VITE_ASSET__BEW1FM9Z__"